export { SalesReportTable } from './SalesReportTable'
